import { useIntl } from '@doxyme/locale';
import {
  OptionButtonContainer,
  Gmail,
  Yahoo,
  Outlook,
  Button,
} from '@doxyme/ui/components/foundations';
import { useSendFromMyEmailTabStyles } from './sendFromMyEmailTab.styles';
import Box from '@mui/material/Box';

import type { JSX } from 'react';

export type SendFromMyEmailTabProps = {
  inviteViaGmail: () => void;
  inviteViaYahoo: () => void;
  inviteViaOutlook: () => void;
  inviteViaDefaultEmail: () => void;
};

export const SendFromMyEmailTab = ({
  inviteViaGmail,
  inviteViaYahoo,
  inviteViaOutlook,
  inviteViaDefaultEmail,
}: SendFromMyEmailTabProps): JSX.Element => {
  const { formatMessage } = useIntl();
  const styles = useSendFromMyEmailTabStyles();

  return (
    <Box css={styles.container}>
      <Box css={styles.wrapper}>
        <OptionButtonContainer
          option={<Gmail css={styles.icon} />}
          label={formatMessage({ id: 'inviteViaEmail.gmail' })}
          onClick={inviteViaGmail}
        />
        <OptionButtonContainer
          option={<Yahoo css={styles.icon} />}
          label={formatMessage({ id: 'inviteViaEmail.yahoo' })}
          onClick={inviteViaYahoo}
        />
        <OptionButtonContainer
          option={<Outlook css={styles.icon} />}
          label={formatMessage({ id: 'inviteViaEmail.outlook' })}
          onClick={inviteViaOutlook}
        />
      </Box>
      <Button
        onClick={inviteViaDefaultEmail}
        css={styles.button}
        type='outline'
      >
        {formatMessage({ id: 'inviteViaEmail.defaultEmail' })}
      </Button>
    </Box>
  );
};
